/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_PlaceholderInputs */

const en_settings_keys_placeholder = /** @type {(inputs: Settings_Keys_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Work laptop`)
};

const id_settings_keys_placeholder = /** @type {(inputs: Settings_Keys_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Laptop kantor`)
};

/**
* | output |
* | --- |
* | "e.g. Work laptop" |
*
* @param {Settings_Keys_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_placeholder = /** @type {((inputs?: Settings_Keys_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_placeholder(inputs)
	return en_settings_keys_placeholder(inputs)
});